<template>
  <section class="container">
    <div class="grid-container">
      <div class="card" v-for="review in reviews" v-bind:key="review" v-bind:id="review.reviewID" :class="review.best ? 'is-best' : 'card'">
        <div class="bg-img" v-bind:style="{ backgroundImage: 'url(' + review.thumbnail + ')' }" >
          <!-- <img :src="review.thumbnail"> -->
          </div>
        <div class="content">
          <div> </div>
          <h4>{{review.username}}</h4>
          <p>{{review.rating}} {{review.caption}}</p>
          <div v-if="review.best">
            <button v-bind:id="review.reviewID" v-on:click="removeBest(review.reviewID)">Remove</button>
          </div>
          <div v-else>
            <button v-bind:id="review.reviewID" v-on:click="makeBest(review.reviewID)">Make Best</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from './firebaseInit'
const CircJSON = require('circular-json')
export default {
  name: 'review',
  data () {
    return {
      reviews: [],
      loading: true
    }
  },
  methods: {
    getReviews () {
      console.log('test')
      db.collection('reviews').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          console.log(doc.id, '=>', doc.data())
          let data = {
            'reviewID': doc.id,
            'caption': doc.data().caption,
            'thumbnail': doc.data().imageURL,
            'rating': doc.data().rating,
            'restaurant': CircJSON.stringify(doc.data().restaurant.id),
            'timestamp': doc.data().timestamp,
            'userId': doc.data().userId,
            'videoURL': doc.data().videoURL,
            'username': 'Error username',
            'best': doc.data().best
          }
          this.getUser(data, doc.data().userId)
        })
      })
    },
    getUser (data, uid) {
      let userRef = db.collection('users').doc(uid)
      userRef.get().then((doc) => {
        if (!doc.exists) {
          console.log('Error getting document')
        } else {
          data['username'] = doc.data().fullname
          this.reviews.push(data)
        }
      })
    },
    makeBest (reviewID) {
      alert('Added best video: ' + reviewID)
      let bestRef = db.collection('reviews').doc(reviewID)
      bestRef.update({'best': true})
      let _review = this.reviews.filter(function (x) { return x.reviewID === reviewID })
      console.log('Best review: ' + _review)
      // this.className = 'is-best';
    },
    removeBest (reviewID) {
      alert('Removedd best video: ' + reviewID)
      let bestRef = db.collection('reviews').doc(reviewID)
      bestRef.update({'best': false})

      let _review = this.reviews.filter(function (x) { return x.reviewID === reviewID })
      console.log('Remove Review: ' + JSON.stringify(_review))
    }
  },
  beforeMount () {
    this.getReviews()
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #d3d3d3;
  border-radius: .25rem;
  margin: 0 5px;
}

.is-best {
  border-width: 5px;
  border-color: #e3b409;
}

.bg-img {
  background-size: cover;
  min-height: 180px;
  background-position: center;
  background-color: #ccc;
}

.content {
  padding: 15px;
}

button {
  background-color: transparent;
  border: 1px solid #2196F3;
  padding: .5rem 1rem;
  cursor: pointer;
  border-radius: .25rem;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 5px;
}

@media screen and (max-width: 800px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
  }
}

@media screen and (max-width: 600px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
  }
}

@media screen and (max-width: 320px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue